import { render, staticRenderFns } from "./GridBadge.vue?vue&type=template&id=30e2386d&"
import script from "./GridBadge.ts?vue&type=script&lang=js&"
export * from "./GridBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports